import React, { Component } from 'react'

export function Download ({ width=15, ...rest }) {
  return (
    <svg width={width} height={width} {...rest} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 15 15">
      <path fill="#C4C4C4" d="M7.5,0C6.3,0,5.2,0.5,4.3,1.4C3.6,2,3.2,2.9,3,3.8C1.3,4.1,0,5.6,0,7.5c0,2.1,1.7,3.8,3.8,3.8h1.8c0.1,0,0.3-0.1,0.4-0.1C6,11.1,6,11,6,10.8c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.4-0.1H3.8C2.2,10.3,1,9.1,1,7.5C1,6,2.1,4.8,3.5,4.7c0.2,0,0.4-0.2,0.4-0.4C4,3.4,4.4,2.7,5,2.1C5.7,1.4,6.6,1,7.5,1S9.3,1.3,10,2.1c0.8,0.8,1.2,2,1,3c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.4,0.2h0.2C13,5.7,14,6.7,14,8s-1,2.3-2.3,2.3H9.5c-0.1,0-0.3,0-0.4,0.1C9,10.6,9,10.7,9,10.8C9,11,9,11.1,9.1,11.2c0.1,0.1,0.2,0.1,0.4,0.1h2.3c1.8,0,3.3-1.5,3.3-3.3c0-1.7-1.3-3.1-3-3.3c0-1.2-0.4-2.4-1.3-3.3C9.8,0.5,8.7,0,7.5,0L7.5,0z M7.5,8C7.2,8,7,8.2,7,8.5v4.9l-1-0.9c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7l1.8,1.7C7.3,14.9,7.3,15,7.5,15c0.2,0,0.2,0,0.3-0.1l1.8-1.7c0.2-0.2,0.2-0.5,0-0.7c-0.2-0.2-0.5-0.2-0.7,0l-1,0.9V8.5C8,8.2,7.8,8,7.5,8L7.5,8z"/>
    </svg>
  )
}

export function Downloaded ({ width=15, ...rest }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 15 12">
    <path fill="#CCA633" d="M7.5,0C6.3,0,5.2,0.5,4.3,1.4C3.6,2,3.2,2.9,3,3.8C1.3,4.1,0,5.6,0,7.5c0,2.1,1.7,3.8,3.8,3.8
    	h8c1.8,0,3.3-1.5,3.3-3.3c0-1.7-1.3-3.1-3-3.3c0-1.2-0.4-2.4-1.3-3.3C9.8,0.5,8.7,0,7.5,0z"/>
    <path fill="#C4C4C4" d="M7.5,0C6.3,0,5.2,0.5,4.3,1.4C3.6,2,3.2,2.9,3,3.8C1.3,4.1,0,5.6,0,7.5c0,2.1,1.7,3.8,3.8,3.8
    	h5.7c0.1,0,0.3-0.1,0.4-0.1C9.9,11.1,10,11,10,10.8c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.4-0.1H3.8C2.2,10.3,1,9.1,1,7.5
    	C1,6,2.1,4.8,3.5,4.7c0.2,0,0.4-0.2,0.4-0.4C4,3.4,4.4,2.7,5,2.1C5.7,1.4,6.6,1,7.5,1S9.3,1.3,10,2.1c0.8,0.8,1.2,2,1,3
    	c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.4,0.2h0.2C13,5.7,14,6.7,14,8s-1,2.3-2.3,2.3H9.5c-0.1,0-0.3,0-0.4,0.1
    	C9,10.6,9,10.7,9,10.8C9,11,9,11.1,9.1,11.2c0.1,0.1,0.2,0.1,0.4,0.1h2.3c1.8,0,3.3-1.5,3.3-3.3c0-1.7-1.3-3.1-3-3.3
    	c0-1.2-0.4-2.4-1.3-3.3C9.8,0.5,8.7,0,7.5,0z"/>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/components/visuals/Cloud.js